import {
	DrivingLessonRecordType as DrivingLessonRecordTypeTs,
	TeachingLessonRecordType as TeachingLessonRecordTypeTs,
} from '@evidia/shared';

const NAMING_MAP: Record<DrivingLessonRecordTypeTs, string> = {
	[DrivingLessonRecordTypeTs.DRIVING]: 'Jízdy',
	[DrivingLessonRecordTypeTs.PV_UV]: 'PV-ÚV',
	[DrivingLessonRecordTypeTs.PV_ZP]: 'PV-ZP',
};

const NAMING_MAP_TEACHING: Record<TeachingLessonRecordTypeTs, string> = {
	[TeachingLessonRecordTypeTs.OP]: 'OP',
	[TeachingLessonRecordTypeTs.PPV]: 'PPV',
	[TeachingLessonRecordTypeTs.OUV]: 'OUV',
	[TeachingLessonRecordTypeTs.TZBJ]: 'TZBJ',
	[TeachingLessonRecordTypeTs.ZP]: 'ZP',
};

export const getDrivingLessonRecordTypeName = (type: DrivingLessonRecordTypeTs) => NAMING_MAP[type];

export const getTeachingLessonRecordTypeName = (type: TeachingLessonRecordTypeTs) => NAMING_MAP_TEACHING[type];
